export const DEVICE_TYPE = 'DEVICE_TYPE';
export const TOKENS_SET = 'TOKENS_SET';
export const DEVICE_SELECTED = 'DEVICE_SELECTED';
export const TOKENS_SELECTED = 'TOKENS_SELECTED';
export const CLEAR_CHECKOUT = 'CLEAR_CHECKOUT';
export const PAYMENT_METHODS = 'PAYMENT_METHODS';
export const UPDATE_PRICE = 'UPDATE_PRICE';
